export default {
      id: "ic_whatsapp-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_whatsapp-usage",
      toString: function () {
        return this.url;
      }
    }